<template>
    <div class="app-container">
      <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
      <BjPage ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :radio="radio"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      :before-query-search="beforeQuerySearch"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @handleRadioChange="handleRadioChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
          <el-col :span="colSpan">
            <el-form-item :label="$t('form.oddNumbers')" prop="orderNo">
              <BjInput v-model="queryParams.orderNo" :placeholder="$t('orderNewPatch.order')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('ExternalOrders.Order')">
              <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('ExternalOrders.Order')" />
            </el-form-item>
          </el-col>
          <el-col v-if="!$store.getters.cusId" :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="receiverName">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" @click="cancelOrder">{{ $t('bulkDelCancelText') }}</el-button>
          </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'failureReason'">
                  {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'shippingWarehouse'">
                  {{ scope.row.circulationStatus == '1' ? scope.row[col.prop] : null }}
                </template>
                <template v-else-if="col.prop === 'orderTime'">
                  <span>{{ scope.row[col.prop] | timeOptimization }}</span>
                </template>
                <template v-else-if="col.prop === 'creationDate'">
                  <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
                </template>
                <template v-else-if="col.prop === 'shippingMethod'">
                  <el-tag v-if="['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(scope.row[col.prop])" type="success">{{ scope.row[col.prop] }}</el-tag>
                  <span v-else>{{ scope.row[col.prop] }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template #header>
                {{ $t('operationText') }}
                <el-tooltip placement="top">
                  <div slot="content">{{ $t('InternalOrder.ps1') }}</div>
                  <i class="el-icon-question" style="color: #082dc3;"></i>
                </el-tooltip>
              </template>
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item command="handleNormal">{{ $t('ThreePartySalesOrder.confirmation') }}</el-dropdown-item>
                    <el-dropdown-item command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi, thirdApi } from '@/api';
  import { ORDER_ABNORMAL_FIVE_ROUTE_LIST, LANG_ZH_EN_PS_LIST } from '@/utils/constants';
  export default {
    name: 'BusinessAbnormalOrderANOMALY',
    components: {
    },
    mixins: [pageMiXin],
    data() {
      return {
        selection: true,
        colSpan: 4,
        ORDER_ABNORMAL_FIVE_ROUTE_LIST,
        LANG_ZH_EN_PS_LIST,
        queryApi: orderApi.getThirdOrderPage,
        // 查询参数
        queryParamsTime_order: [],
        queryParams: {
          orderNo: null,
          operationType: Number(2),
          circulationStatus: Number(1),
          storeIdList: [],
          channel: null,
          orderStartTime: null,
          orderEndTime: null,
          cusId: null,
          payStatus: '1',
        },
        labelList1: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('orderNewPatch.CustomerOrder'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 180 },
          { label: this.$t('ExternalOrders.form.Channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false },
          { label: this.$t('ExternalOrders.form.Store'), prop: 'storeName', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Reason'), prop: 'failureReason', isCheck: true, disabled: false, width: '185' },
          { label: this.$t('orderNewPatch.Detail'), prop: 'shippingWarehouse', isCheck: true, disabled: false, width: '185' },
          { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false, width: '135' },
          { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false, width: '135' },
          { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuantity', isCheck: true, disabled: false, width: '90' },
          { label: this.$t('ExternalOrders.newAdd.ShippingMethod'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '130'},
          { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.orderStartTime = (v || [])[0];
        this.queryParams.orderEndTime = (v || [])[1];
      },
    },
    mounted() {},
    methods: {
      // 查看
      onView(row) {
        this.toOuterOrder(row, 'view');
      },
      command(text, row) {
        switch (text) {
          case 'edit':
            this.toOuterOrder(row);
            break;
          case 'handleNormal':
            this.handleNormal(row);
            break;
          case 'cancel':
            this.onDelete(row);
            break;
        }
      },
      // 跳外部详情
      toOuterOrder(item, orderType) {
        if (orderType) {
          this.$router.push({
            name: 'BusinessThirdOrderCSGView',
            query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus, type: orderType },
          });
        } else {
          this.$router.push({
            name: 'BusinessThirdOrderCSGView',
            query: { id: '', code: item.outerOrderNo, status: item.totalOrderStatus },
          });
        }
      },
      /** 异常单转正 */
      handleNormal(item) {
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          // 如果是新订单1或异常订单2，调用外部订单异常转正接口
          thirdApi.thirdOrderToNormal({ outerOrderNo: item.outerOrderNo }).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 2000);
            }
          });
        });
      },
      // 删除 cancelThirdPartyGoods
      onDelete(item) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          thirdApi.cancelThirdPartyGoods([item.outerOrderNo]).then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        })
        .catch(() => {});
      },
      // 批量删除 循环调用
      async cancelOrder() {
          if (!this.selectedRows.length) {
            this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
            return;
          }
          this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
              let promise = Promise.resolve();
              this.selectedRows.forEach((item) => {
                promise = promise.then(() => {
                  return new Promise(resolve => {
                    thirdApi.cancelThirdPartyGoods([item.outerOrderNo]).then(res => {
                      if (res.failed === false) {
                        resolve();
                      }
                    });
                  });
                });
              });
              return promise.then(() => {
                setTimeout(() => {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                }, 1500);
              });
          });
      },
      beforeResetSearch() {
        this.queryParamsTime_order = null;
        this.queryParams.storeIdList = null;
        this.queryParams.cusId = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
